import { Color } from 'csstype'
import { CidadaoListagemGestantePuerperaQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-gestantePuerpera'

import { AcompanhamentoCondicaoSaudeVacinasConsolidadoSection } from '../AcompanhamentoCondicaoSaudeVacinasConsolidadoSection'
import { AcompanhamentoCondicaoSaudeGestantePuerperaConsultasPuerperioSection } from './AcompanhamentoCondicaoSaudeGestantePuerperaConsultasPuerperioSection'
import { AcompanhamentoCondicaoSaudeGestantePuerperaExamesSection } from './AcompanhamentoCondicaoSaudeGestantePuerperaExamesSection'
import { AcompanhamentoCondicaoSaudeGestantePuerperaInfoSection } from './AcompanhamentoCondicaoSaudeGestantePuerperaInfoSection'
import { AcompanhamentoCondicaoSaudeGestantePuerperaMedicoesSection } from './AcompanhamentoCondicaoSaudeGestantePuerperaMedicoesSection'
import { AcompanhamentoCondicaoSaudeGestantePuerperaVisitasDomiciliaresSection } from './AcompanhamentoCondicaoSaudeGestantePuerperaVisitasDomiciliaresSection'

interface AcompanhamentoCondicaoSaudeGestantePuerperaAccordionSectionProps {
  row: CidadaoListagemGestantePuerperaQueryModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeGestantePuerperaAccordionSection(
  props: Readonly<AcompanhamentoCondicaoSaudeGestantePuerperaAccordionSectionProps>
) {
  const { row, iconColor } = props
  const gestantePuerpera = row.preNatalPuerperio

  return (
    <>
      <AcompanhamentoCondicaoSaudeGestantePuerperaInfoSection
        gestantePuerpera={gestantePuerpera}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeVacinasConsolidadoSection vacinas={gestantePuerpera?.vacinas} iconColor={iconColor} />
      <AcompanhamentoCondicaoSaudeGestantePuerperaMedicoesSection
        medicoesPreNatal={gestantePuerpera?.medicoesPreNatal}
      />
      <AcompanhamentoCondicaoSaudeGestantePuerperaExamesSection
        examesRealizadosPreNatal={gestantePuerpera?.examesRealizadosPreNatal}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeGestantePuerperaVisitasDomiciliaresSection
        visitasDomiciliares={gestantePuerpera?.visitasDomiciliares}
      />
      <AcompanhamentoCondicaoSaudeGestantePuerperaConsultasPuerperioSection
        atendimentosPreNatalPuerperio={gestantePuerpera?.atendimentosPreNatalPuerperio}
        dataUltimaConsultaPuerperio={gestantePuerpera?.atendimentosPreNatalPuerperio?.dataUltimaConsultaPuerperio}
      />
    </>
  )
}
